module.exports = __webpack_public_path__ + "img/back01_sp.10410ee4.jpg";